import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f5aab70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "warning-img" }
const _hoisted_2 = {
  key: 0,
  class: "record-icon"
}
const _hoisted_3 = { class: "warning-desc" }
const _hoisted_4 = { class: "warning-desc-tag" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-chushimao2" }, null, -1))
const _hoisted_6 = { class: "warning-desc-title" }
const _hoisted_7 = { class: "warning-desc-time" }

import { PropType } from 'vue'

import { IWarningInfo } from '@/utils/interface'
import imgBox from '@/components/imgBox/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  list: {
    type: Array as PropType<IWarningInfo[]>,
    default() {
      return []
    }
  }
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item, index) => {
    return (_openBlock(), _createBlock(_component_router_link, {
      class: "warning-list-item",
      key: index,
      to: `/retrospect/${item.exceptionId}`
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(imgBox, {
            detResultList: item.detResultList,
            imageUrl: item.imageUrl
          }, null, 8, ["detResultList", "imageUrl"]),
          (item.record)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "已转任务"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(item.exceptionDescribe), 1)
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(item.storeName) + "/" + _toDisplayString(item.addressName), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(item.time), 1)
        ])
      ]),
      _: 2
    }, 1032, ["to"]))
  }), 128))
}
}

})